<template>
  <vs-popup :title="$t('ViewSerials')" :active.sync="popupActive">
    <div>
      <data-grid
        ref="grid"
        stripe
        :data-source="gridDataSource"
        :search-data="gridSearchData"
        :columns="[
          { title: $t('Serial'), sort: 'Serial' },
          { title: $t('ShelveName'), sort: 'ShelveName' },
          { title: $t('StoreName'), sort: 'StoreName' },
        ]"
      >
        <template slot-scope="{ row }">
          <td style="width: 17%">
            {{ row.serial }}
          </td>
          <td style="width: 40%">
            {{ row.shelveName }}
          </td>
          <td style="width: 40%">
            {{ row.storeName }}
          </td>
        </template>
      </data-grid>
    </div>
  </vs-popup>
</template>
<script>
import DataGrid from "@/components/datagrid/DataGrid";
export default {
  name: "warehouseManagement_Reports_SerialBalance_SerialPopup",
  props: {
    show: { default: false },
    popupService: {},
  },
  data() {
    return {
      gridDataSource: { data: [] },
      gridSearchData: {},
      SerialPopup: false,
    };
  },
  computed: {
    popupActive: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  watch: {
    show() {
      this.gridDataSource = { type: "app", service: this.popupService };
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 0);
    },
  },
  components: {
    DataGrid,
  },
};
</script>
